import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import propTypes from "../../../../../../constants/propTypes";
import {
  showSnackNotificationAction,
  closeModalDialog,
} from "../../../../../../actions/layoutActions";
import {
  performDeleteRequest,
  setReload,
} from "../../../../../../actions/dataComponentActions";
import { processDeleteRequestStatus } from "../../../../../../utils/dataComponentUtils";
import { getDataComponent } from "../../../../../../reducers/dataComponentReducer";
import DeleteConfirmation from "../../../../../ui/DeleteConfirmation";
import { reloadDataComponent } from "../../../../../../actions/initializeStoreActions";
import { PAYMENT_TERMS_SELECT } from "../../../../../../constants/DataComponents";

export class DeletePaymentTermsPage extends Component {
  componentDidUpdate({ dataComponent: prevDataComponent }) {
    const {
      dataComponent,
      dataComponentId,
      closeModalDialog,
      setReload,
      reloadDataComponent,
    } = this.props;
    processDeleteRequestStatus(prevDataComponent, dataComponent, {
      onSuccess: () => {
        closeModalDialog();
        setReload(dataComponentId, true);
        reloadDataComponent(PAYMENT_TERMS_SELECT);
      },
      onError: this.handleDeleteRequestError,
    });
  }

  handleDeleteRequestError = ({ data }) => {
    const { showSnackNotificationAction } = this.props;

    data.errors.map(error => {
      if (error.global) {
        showSnackNotificationAction(error.title);
      }
    });
  };

  handleDelete = () => {
    const { id, performDeleteRequest, dataComponentId, params } = this.props;
    performDeleteRequest(dataComponentId, id, params);
  };

  render() {
    const { title } = this.props;
    return <DeleteConfirmation title={title} onDelete={this.handleDelete} />;
  }
}

DeletePaymentTermsPage.propTypes = {
  title: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  dataComponentId: PropTypes.string.isRequired,
  dataComponent: propTypes.dataComponent.isRequired,
  performDeleteRequest: PropTypes.func.isRequired,
  closeModalDialog: PropTypes.func.isRequired,
  showSnackNotificationAction: PropTypes.func.isRequired,
  setReload: PropTypes.func.isRequired,
  reloadDataComponent: PropTypes.func,
  params: PropTypes.shape({}),
};

const mapStateToProps = (state, { dataComponentId }) => {
  const dataComponent = getDataComponent(dataComponentId, state);
  return {
    dataComponent,
  };
};

const mapDispatchToProps = {
  performDeleteRequest,
  closeModalDialog,
  showSnackNotificationAction,
  setReload,
  reloadDataComponent,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DeletePaymentTermsPage);
